// extracted by mini-css-extract-plugin
module.exports = {"chatBtn":"chatBtn___3CK5W","disable":"disable___1kH_h","on":"on___2LEKk","icon":"icon___1-y4x","has-red-dot":"has-red-dot___1JDMC"};